// The AI tools Pabs can work in, as the web app presents them. Which ones a
// visitor is offered still comes from /api/client-setup/config.
const {NATIVE_PLUGIN_CLIENTS}=require('../../shared/nativePluginClients');
export const CLIENT_TOOLS=[
  {id:'codex',label:'Codex',icon:'codex'},
  {id:'claude',label:'Claude Code',icon:'claude-code'},
  ...NATIVE_PLUGIN_CLIENTS.map(tool=>tool.id==='chatgpt' ? {...tool,icon:'chatgpt-mark',iconFormat:'png',monochrome:true} : tool),
  {id:'cursor',label:'Cursor',icon:'cursor',monochrome:true},
  {id:'lovable',label:'Lovable',icon:'lovable'},
  {id:'bolt',label:'Bolt',icon:'bolt'},
  {id:'v0',label:'v0',icon:'v0',monochrome:true},
  {id:'replit',label:'Replit',icon:'replit'},
];

export const clientLabel=id=>CLIENT_TOOLS.find(tool=>tool.id===id)?.label || id;
export const clientIconSrc=tool=>`/images/client-tools/${tool.icon}.${tool.iconFormat || 'svg'}`;

// Local tools need the built package. Browser tools carry their connector
// setup (`host`) from the server.
export function availableClientTools(config) {
  if(!config?.enabled) return {local:[],remote:[],native:[],tools:[]};
  const remote=(config.remote_clients || []).map(host=>({...(CLIENT_TOOLS.find(tool=>tool.id===host.id) || {id:host.id,label:host.label}),host}));
  const native=(config.native_clients || []).filter(host=>NATIVE_PLUGIN_CLIENTS.some(tool=>tool.id===host.id)).map(host=>({...host,...CLIENT_TOOLS.find(tool=>tool.id===host.id),native:true}));
  const local=config.package_ready ? CLIENT_TOOLS.filter(tool=>config.clients?.includes(tool.id) && !native.some(item=>item.id===tool.id)) : [];
  const tools=[...local,...remote,...native].sort((a,b)=>CLIENT_TOOLS.findIndex(tool=>tool.id===a.id)-CLIENT_TOOLS.findIndex(tool=>tool.id===b.id));
  return {local,remote,native,tools};
}

// Every normal install uses npx. Previews connect to their own Pabs server.
export const NPM_PACKAGE='getpabs';

// A plan id pre-selects that plan when the person connects the project.
export function installCommand({client,windows=false,testMode=false,planId=null}) {
  if(!testMode) {
    const origin=window.location.origin;
    const server=origin==='https://www.pabs.co.nz'?'':` --server '${origin.replace(/'/g,windows?"''":"'\\''")}'`;
    return `npx -y ${NPM_PACKAGE}@latest install --client ${client}${planId?` --plan ${String(planId).replace(/\D/g,'')}`:''}${server}`;
  }
  return scriptInstallCommand({client,windows,testMode,planId});
}

// The hosted script remains available for test mode and installations without npm.
export function scriptInstallCommand({client,windows=false,testMode=false,planId=null}) {
  const url=`${window.location.origin}/install/${client}${planId?`?plan=${encodeURIComponent(planId)}`:''}`;
  return windows ? `irm ${url} | node -${testMode ? ' --test-mode' : ''}` : `curl -fsSL ${url} | node${testMode ? ' - --test-mode' : ''}`;
}

// Pasted into the agent's chat. Naming the tool lets an agent notice it was
// given another tool's command before running it; the installer checks too.
export const installPrompt=(tool,command)=>tool.native
  ? `Install Pabs for ${tool.label}. Run this and finish the plugin setup:\n${command}`
  : `Install Pabs for ${tool.label} in this project. Only run this if you are ${tool.label}:\n${command}`;

export const localInitPrompt=client=>client==='claude-desktop' ? 'Use Pabs to initialize this project.' : 'Use pabs-init to initialize this project.';
